import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { uploadProfileImage } from '@/core/http/me.api'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

import { Button } from '@/components/Button/Button'
import sessionService from '@/app-domains/user/session/session.service'
import './SettingsAreaProfile.scoped.sass'
import ToastService from '@/components/Toast/Toast.service'

export function SettingsAreaProfile () {
  const meInfo = useSelector(state => state.me)
  const [submitting, setSubmitting] = useState(false)
  const [value, setValue] = useState(meInfo.me.preferences?.signature || '')
  const onSubmitHandler = async () => {
    setSubmitting(true)
    await sessionService.updateSignature(value)
    ToastService.show({
      title: 'Signature updated',
      message: 'Signature properly updated',
      type: 'success'
    })
    setSubmitting(false)
  }
  const [profileImage, setProfileImage] = useState(meInfo.me.profilePictureUrl || '')

  const onChangeProfileImage = async (base64Image, file) => {
    setSubmitting(true)
    // Validate image size here
    const data = {
      filename: file.name,
      file: base64Image.split(',')[1],
      contentType: file.type
    }
    // eslint-disable-next-line
    const res = await uploadProfileImage(data)
    setProfileImage(base64Image)
    sessionService.setMeInfo()
    setSubmitting(false)
  }

  const handleFileInput = async (e) => {
    // eslint-disable-next-line no-undef
    const reader = new FileReader()
    reader.readAsDataURL(e.target.files[0])
    reader.onload = () => onChangeProfileImage(reader.result, e.target.files[0])
    ToastService.show({
      title: 'Profile picture updated',
      message: 'Profile picture properly updated',
      type: 'success'
    })
  }
  return (
    <div className="settings-general">
      <div className="group">
        <div className="title">
          Profile Image
        </div>
        <div className="group-content">
          <div className="settings-area-general__upload-image">
            <div className='settings-area-general__profile-picture-container'>
              <img src={profileImage || '/assets/img/avatar-placeholder.png'} className="settings-area-general__profile-picture" />
            </div>
            <label className="custom-file-upload" disabled={submitting}>
              <input type="file" onChange={handleFileInput} />
              Change image
            </label>
          </div>
        </div>
      </div>
      <div className="group flex-col">
        <div className="title">
          Signature
        </div>
        <div className='group-content'>
          <div className='signature-save-container'>
            <ReactQuill theme="snow" value={value} onChange={setValue}/>
          </div>
          <div className="save-button-container">
            <Button
              content='Save'
              disabled={submitting}
              variant="outlined"
              click={onSubmitHandler}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
